import { inject, injectable } from 'inversify'
import axios from 'axios'
import fetch from 'cross-fetch'
import { GraphQLClient } from 'graphql-request'
import {
  ActionCable,
  ActionCableConsumer,
  ActionCableSubscription,
  AddAngelInvestmentInvitationRequestInput,
  AddAngelInvitationRequestInput,
  AddCompanyInvestmentRequestInput,
  AddCompanyMemberRequestInput,
  AddCompanyReferenceRequestInput,
  AddExperienceRequestInput,
  AddFootprintToJobInputBase,
  AddInvestorRequestInput,
  AddMemberInvitationRequestInput,
  AddMyInvestmentRequestInput,
  AddMyJobBookmarkRequestInput,
  AddPitchAttachmentRequestInput,
  AddProductRequestInput,
  AddUserReferenceRequestInput,
  AddVcInvestmentInvitationRequestInput,
  AddVcInvitationRequestInput,
  AddVehicleItemPortfolioAttachmentRequestInput,
  AddVehicleItemRoundAttachmentRequestInput,
  AddVehicleMemberRequestInput,
  ApplyForJobRequestInput,
  BillingPortalBase,
  CreateArticleAttachmentRequestInput,
  CreateBillingPortalSessionInputBase,
  CreateChatMessageThreadRequestInput,
  CreateChatMessageThreadsSubscriptionRequestInput,
  CreateCompanyArticleRequestInput,
  CreateJobAttachmentRequestInput,
  CreateJobRequestInput,
  CreateMyArticleRequestInput,
  CreatePitchRequestInput,
  CreateRecruitSubscriptionInputBase,
  CreateSkillRequestInput,
  CreateVehicleItemPortfolioMeetingRequestInput,
  CreateVehicleItemPortfolioNoteRequestInput,
  CreateVehicleItemRequestInput,
  CreateVehicleItemRoundRequestInput,
  CreateVehicleRequestInput,
  CreateVehicleStatusRequestInput,
  DeleteArticleRequestInput,
  DeleteJobRequestInput,
  DeletePitchAttachmentRequestInput,
  DeletePitchRequestInput,
  DeleteVehicleItemPortfolioAttachmentRequestInput,
  DeleteVehicleItemPortfolioMeetingRequestInput,
  DeleteVehicleItemPortfolioNoteRequestInput,
  DuplicateJobRequestInput,
  FetchAngelsRequestInput,
  FetchAngelsRequestOutput,
  FetchArticleRequestInput,
  FetchArticleRequestOutput,
  FetchChatMessagesRequestInput,
  FetchChatMessagesRequestOutput,
  FetchChatMessageThreadsRequestInput,
  FetchCompaniesRequestInput,
  FetchCompaniesRequestOutput,
  FetchCompaniesWithJobsRequestInput,
  FetchCompaniesWithJobsRequestOutput,
  FetchCompanyArticleRequestInput,
  FetchCompanyArticleRequestOutput,
  FetchCompanyJobsRequestInput,
  FetchCompanyJobsRequestOutput,
  FetchCompanyRequestInput,
  FetchFollowersRequestInput,
  FetchFollowersRequestOutput,
  FetchFollowingRequestInput,
  FetchFollowingRequestOutput,
  FetchForexRateRequestInput,
  FetchForexRatesRequestInput,
  FetchJobApplicationsRequestInput,
  FetchJobApplicationsRequestOutput,
  FetchJobBookmarksRequestInput,
  FetchJobBookmarksRequestOutput,
  FetchJobFootprintsRequestInput,
  FetchJobFootprintsRequestOutput,
  FetchJobRequestInput,
  FetchJobsRequestInput,
  FetchJobsRequestOutput,
  FetchLocationRequestInput,
  FetchLocationsRequestInput,
  FetchMyArticlesRequestInput,
  FetchMyArticlesRequestOutput,
  FetchMyCompanyArticlesRequestInput,
  FetchMyCompanyArticlesRequestOutput,
  FetchMyCompanyReferencesRequestInput,
  FetchMyCompanyReferencesRequestOutput,
  FetchMyCompanyRequestInput,
  FetchMyJobBookmarksRequestInput,
  FetchMyJobBookmarksRequestOutput,
  FetchMyJobsRequestInput,
  FetchMyJobsRequestOutput,
  FetchMyReferencesRequestInput,
  FetchMyReferencesRequestOutput,
  FetchNotificationsRequestInput,
  FetchPaginatedChatMessageThreadsRequestInput,
  FetchPaginatedChatMessageThreadsRequestOutput,
  FetchSubsidiesRequestInput,
  FetchSubsidiesRequestOutput,
  FetchSubsidyPurposeRequestInput,
  FetchSubsidyRequestInput,
  FetchUserArticlesRequestInput,
  FetchUserArticlesRequestOutput,
  FetchUserRequestInput,
  FetchVehicleItemsForAllStatusesRequestInput,
  FetchVehicleItemsForAllStatusesRequestOutput,
  FetchVehicleItemsRequestInput,
  FetchVehicleItemsRequestOutput,
  FollowableEntityEntityType,
  GraphQLErrors,
  IAppCredentials,
  IArticleAttachmentBase,
  IArticleBase,
  IArticlesService,
  IChatMessageThreadBase,
  IChatService,
  ICompaniesService,
  ICompanyBase,
  ICompanyInputBase,
  ICompanyReferenceBase,
  ICompanyReferencesService,
  IExperienceBase,
  IForexRateBase,
  IForexService,
  IInvestmentBase,
  IInvestmentsService,
  IInvestorMemberBase,
  IInvitationBase,
  IInvitationLinkBase,
  IInvitationsService,
  IJobApplicationBase,
  IJobApplicationsService,
  IJobAttachmentBase,
  IJobBase,
  IJobBookmarkBase,
  IJobBookmarksService,
  IJobCategoriesService,
  IJobsService,
  IJobTagBase,
  IJobTagsService,
  ILocationBase,
  ILocationsService,
  IMarketBase,
  IMarketsService,
  IMyCompanyBase,
  IMyCompanyMemberBase,
  IMyPitchBase,
  InitializePmsRquestInput,
  INotificationsService,
  IPitchAttachmentBase,
  IPitchAttachmentsService,
  IPitchBase,
  IPitchesService,
  IPMSService,
  IPortfolioAttachmentBase,
  IPortfolioBase,
  IPortfolioMeetingBase,
  IPortfolioNoteBase,
  IPreferences,
  IProductBase,
  ISkillBase,
  ISubscriptionsService,
  ISubsidiesService,
  ISubsidyBase,
  ISubsidyPurposeBase,
  IUserBase,
  IUserProfileBase,
  IUserProfileInputBase,
  IUserReferenceBase,
  IUserReferencesService,
  IUsersService,
  IVehicleBase,
  IVehicleDashboardBase,
  IVehicleItemBase,
  IVehicleItemRoundAttachmentBase,
  IVehicleItemRoundBase,
  IVehicleMemberBase,
  IVehicleStatusBase,
  IViewerBase,
  IViewerService,
  JobCategoryBase,
  MarkAllMessagesAsReadRequestInput,
  MarkNotificationsAsReadRequestInput,
  MarkNotificationsAsReadRequestOutput,
  PaymentIntentBase,
  RemoveCompanyMemberRequestInput,
  RemoveCompanyReferenceRequestInput,
  RemoveExperienceRequestInput,
  RemoveInvestmentRequestInput,
  RemoveInvestorRequestInput,
  RemoveMyJobBookmarkRequestInput,
  RemovePitchAttachmentFromPitchRequestInput,
  RemoveProductRequestInput,
  RemoveUserReferenceRequestInput,
  SearchCompanyRequestInput,
  SearchUserRequestInput,
  SendChatMessageRequestInput,
  ToggleArticleLikedStateRequestInput,
  ToggleFollowCompanyRequestInput,
  ToggleFollowUserRequestInput,
  UpdateCompanyArticleRequestInput,
  UpdateCompanyMemberRequestInput,
  UpdateCompanyNotificationSettingsRequestInput,
  UpdateCompanyReferenceRequestInput,
  UpdateCompanyRequestInput,
  UpdateExperienceRequestInput,
  UpdateInvestmentRequestInput,
  UpdateInvestorRequestInput,
  UpdateJobRequestInput,
  UpdateMeRequestInput,
  UpdateMyArticleRequestInput,
  UpdateMyCompanyReferenceRequestInput,
  UpdateMyReferenceRequestInput,
  UpdatePitchAttachmentRequestInput,
  UpdatePitchRequestInput,
  UpdateProductRequestInput,
  UpdateUserNotificationSettingsRequestInput,
  UpdateUserReferenceRequestInput,
  UpdateVehicleItemPortfolioMeetingRequestInput,
  UpdateVehicleItemPortfolioNoteRequestInput,
  UpdateVehicleItemPortfolioRequestInput,
  UpdateVehicleItemRequestInput,
  UpdateVehicleItemRoundRequestInput,
  UpdateVehicleMemberRequestInput,
  UpdateVehicleRequestInput,
  UpdateVehicleStatusRequestInput,
  ValidInvitationTokenRequestInput,
} from '@/types'
import { isBrowser } from '@/utils'
import { getSdk } from '@/lib/generated/sdk'
import symbols from '@/symbols'
import ForbiddenError from '@/errors/ForbiddenError'
import UnauthenticatedError from '@/errors/UnauthenticatedError'
import RequestTimeoutError from '@/errors/RequestTimeoutError'

@injectable()
export default class AppAPIGateway
  implements
    IViewerService,
    IUsersService,
    ICompaniesService,
    IArticlesService,
    IInvestmentsService,
    IChatService,
    IMarketsService,
    INotificationsService,
    IPitchesService,
    IPitchAttachmentsService,
    ILocationsService,
    IJobCategoriesService,
    IJobTagsService,
    IJobsService,
    ISubscriptionsService,
    IJobApplicationsService,
    IJobBookmarksService,
    IInvitationsService,
    IJobBookmarksService,
    IUserReferencesService,
    ICompanyReferencesService,
    IPMSService,
    IForexService,
    ISubsidiesService {
  @inject(symbols.IAppCredentials) private credentials: IAppCredentials

  @inject(symbols.IPreferences) private preferences: IPreferences

  private _actionCable: ActionCable = null

  private _actionCableConsumer: ActionCableConsumer = null

  private _actionCableSubscriptions: Record<string, ActionCableSubscription> = {}

  private sdk: ReturnType<typeof getSdk> = null

  /**
   * ChatMessages の Relay Connection のページ送り用
   */
  private _fetchStartupsCursors = ''

  private _fetchVentureCapitalsCursors = ''

  private _fetchAngelsCursors = ''

  private _fetchCompaniesWithJobsCursors = ''

  private _fetchInvestmentsWithJobsOfVcCursors: Record<string, string> = {}

  private _fetchInvestmentsWithJobsOfAngelCursors: Record<string, string> = {}

  private _chatMessagesCursors: Record<string, string> = {}

  private _fetchArticlesCursors: Record<string, string> = {}

  private _fetchJobsCursors = ''

  private _fetchJobFootprintsCursors: Record<string, string> = {}

  private _fetchMyJobsCursors: Record<string, string> = {}

  private _fetchMyJobBookmarksCursors = ''

  private _fetchCompanyJobsCursors: Record<string, string> = {}

  private _fetchCompanyArticlesCursors: Record<string, string> = {}

  private _fetchMyCompanyArticlesCursors: Record<string, string> = {}

  private _fetchFollowingCursors: Record<string, string> = {}

  // user と company で同じ slug が考えられるのでそれぞれ用意
  private _fetchCompanyFollowersCursors: Record<string, string> = {}

  private _fetchUserFollowersCursors: Record<string, string> = {}

  private _fetchUserArticlesCursors: Record<string, string> = {}

  private _fetchVehicleItemsCursors: Record<string, string> = {}

  private _fetchVehicleItemsForEachStatusCursors: Record<string, string> = {}

  private _fetchSubsidiesCursors = ''

  // setTimeout の delay オプションに使用
  private readonly _timeoutDelay = 15000

  constructor() {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/graphql`
    const client = new GraphQLClient(url, {
      // fetch をラップして access-token, uid をインターセプトする処理
      fetch: async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
        let response: Response

        const abortController = new AbortController()
        const timeoutID = setTimeout(() => {
          abortController.abort()
        }, this._timeoutDelay)

        try {
          response = await fetch(input, { ...init, signal: abortController.signal })
          // 送ったトークンの有効性を検証
          if (response.status !== 500) {
            // 500 エラーのケースでは uid は返って来ないのでログアウトさせられてしまうため 500 以外のケースを処理
            const oldAccessToken = init.headers['access-token'] as string
            const uid = response.headers.get('uid')
            this._handleUnauthenticated(oldAccessToken, uid)
          }

          // 送ったトークンが valid なら新しいものを保存
          const newAccessToken = response.headers.get('access-token')
          this._setNewAccessToken(newAccessToken)
        } catch (e) {
          // TODO: eslint-disable-next-line を削除
          // e instanceof DOMException && e.name == "AbortError" を条件文にすると ReferenceError: DOMException is not defined エラーが表示されるので、一旦後半の条件文のみ使用
          // eslint-disable-next-line consistent-return,@typescript-eslint/no-unsafe-member-access
          if (e.name === 'AbortError') {
            // 既知の問題として
            // タイムアウト時にはトークンが更新できない。
            // サーバー側の `batch_request_buffer_throttle` で設定している時間（1分）が過ぎると
            // トークンが無効になり、フロントでは強制ログアウトになる。
            // ただ、タイムアウトを設定しない場合も、サーバーからレスポンスを待たずリクエストを中止した場合や
            // そもそもレスポンスが返ってこない場合にはトークンが更新できないため、
            // トークン更新は諦めてタイムアウトをハンドリングする方を選択した仕様になっている。
            throw new RequestTimeoutError('リクエストがタイムアウトしました。時間をおいて再度お試しください。', {
              input,
              init,
            })
          }

          // 他のエラーを握りつぶさないように再度スロー
          throw e
        } finally {
          // 正常時もエラーを投げたときもタイムアウト用のタイマーをクリア
          clearTimeout(timeoutID)
        }

        return response
      },
    })

    this.sdk = getSdk(client)
  }

  /**
   * WebSocket の初期化
   */
  initChatWebSocket(): void {
    // ActionCable がブラウザ環境以外で利用を想定しておらず
    // SSR のときに死ぬので、ちょっとごちゃるけどサーバーサイドでは処理しない
    if (!isBrowser()) {
      return
    }

    // 既に両方初期化されてる場合は処理しない
    if (this._actionCable && this._actionCableConsumer) {
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    this._actionCable = require('@rails/actioncable') as ActionCable
    this.openChatConnection()
  }

  /**
   * action cable の consumer を作成
   */
  openChatConnection(): void {
    // 最新の credentials を取得
    const credentials = this.credentials.getLatestCredentials()
    const url = `${process.env.NEXT_PUBLIC_BACKEND_WS_BASE_URL}/cable/?access-token=${credentials.accessToken}&client=${credentials.client}&uid=${credentials.uid}`
    // 未接続の場合、もしくは credentials が違う場合、新しい Consumer を作成
    if (!this._actionCableConsumer || this._actionCableConsumer?.url !== url) {
      this._actionCableConsumer = this._actionCable.createConsumer(url)
      return
    }

    // credentials が最新の場合
    if (this._actionCableConsumer.url === url) {
      // 既に active な connection があればアーリーリターン
      if (this._actionCableConsumer.connection.isActive()) {
        return
      }

      // active な connection がなければ再接続
      this._actionCableConsumer.connect()
    }
  }

  // Connection が切断された場合に再接続する
  reopenChatConnection(): void {
    if (!this._actionCableConsumer) {
      return
    }

    // 既に active な connection があればアーリーリターン。わざわざ disconnect する必要はないので connection をそのまま使う。
    if (this._actionCableConsumer.connection.isActive()) {
      return
    }

    this._actionCableConsumer.disconnect()
    this.openChatConnection()
  }

  /**
   * Subscription を利用してメッセージを送信
   * @param input
   */
  sendChatMessage(input: SendChatMessageRequestInput): boolean {
    return this._actionCableSubscriptions[input.chatMessageTreadSlug].perform('send_message', {
      message_body: input.messageBody,
      message_thread_slug: input.chatMessageTreadSlug,
      message_files: input.messageFiles,
      deduplication_id: input.deduplicationId,
    })
  }

  private async _post<T>(query: string, variables: Record<string, unknown>): Promise<T & GraphQLErrors> {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/graphql`
    const result = await axios.post<T & GraphQLErrors>(
      url,
      {
        query,
        variables,
      },
      {
        headers: this._headers(),
      }
    )

    if (result.data.errors) {
      // エラーがある場合
      if (result.data.errors[0]?.message === 'Forbidden') {
        throw new ForbiddenError('Server responded with "Forbidden".')
      }
    }

    // TODO: eslint-disabled-next-line を解消する
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const newAccessToken = typeof result.headers['access-token'] === 'string' ? result.headers['access-token'] : ''
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
    const uid = typeof result.headers.uid === 'string' ? result.headers.uid : ''
    this._handleUnauthenticated(this.credentials.accessToken, uid)
    this._setNewAccessToken(newAccessToken)

    return result.data
  }

  private _setNewAccessToken(newAccessToken: string): void {
    // 同時に複数 post した場合、新しい access-token はひとつのレスポンスにしか返ってこないため
    // access-token が空でないときのみ値を更新する
    if (isBrowser() && newAccessToken) {
      this.credentials.updateAccessToken(newAccessToken)
    }
  }

  // ログイン済で accessToken をつけてるのに uid が返ってこないのは
  // 保持してる accessToken が期限切れのためなので認証エラーにする
  private _handleUnauthenticated(oldAccessToken: string, uid: string | null): void {
    if (!oldAccessToken) {
      // oldAccessToken がないのはログインしてないケース
      return
    }

    if (uid) {
      // uid が返ってくるのは API に渡した oldAccessToken が有効なケース
      return
    }

    throw new UnauthenticatedError('Uid is empty on Response Header.')
  }

  // API へリクエストする際に使用する headers を返すメソッド
  private _headers(): HeadersInit {
    const credentials = this.credentials.getLatestCredentials()
    return {
      'X-PREFERRED-LANGUAGE': this.preferences.language,
      'access-token': credentials.accessToken || '',
      uid: credentials.uid || '',
      client: credentials.client || '',
    }
  }

  // ============================================================
  // Viewer
  // ============================================================
  async fetchMe(): Promise<IViewerBase> {
    const variables = {
      articlesAfter: '',
      articlesBefore: '',
      articlesFirst: 20,
      notificationsAfter: '',
      notificationsBefore: '',
      notificationsFirst: 5,
    }

    const response = await this.sdk.fetchMe(variables, this._headers())

    return response.me
  }

  async updateMe(input: UpdateMeRequestInput): Promise<IViewerBase> {
    const response = await this.sdk.updateMe(
      {
        input: {
          attributes: input,
        },
      },
      this._headers()
    )

    return response.updateMe
  }

  async leaveService(): Promise<void> {
    await this.sdk.leaveService(
      {
        input: {},
      },
      this._headers()
    )
  }

  // ============================================================
  // Users
  // ============================================================
  async searchUser(input: SearchUserRequestInput): Promise<IUserBase[]> {
    const response = await this.sdk.searchUser(
      {
        query: input.searchWord,
      },
      this._headers()
    )

    return response.searchUser.nodes
  }

  async fetchAngels(input: FetchAngelsRequestInput): Promise<FetchAngelsRequestOutput> {
    // サーバー側から実行するときはページ送りしないので、 after は指定しない
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchAngelsCursors
    }

    const response = await this.sdk.fetchAngels(
      {
        after,
        before: '',
        first: input.limit,
        maxInvestmentAmount: input.maxInvestmentAmount ? input.maxInvestmentAmount : null,
        minInvestmentAmount: input.minInvestmentAmount ? input.minInvestmentAmount : null,
        investmentTargetMarketIds: input.investmentTargetMarketIds ? input.investmentTargetMarketIds : [],
        investmentTargetRoundIds: input.investmentTargetRoundIds ? input.investmentTargetRoundIds : [],
        locationIds: input.locationIds ? input.locationIds : [],
        currencyUnit: input.currencyUnit ? input.currencyUnit : null,
        orderBy: input.orderBy ? input.orderBy : null,
        query: input.searchWord ? input.searchWord : '',
      },
      this._headers()
    )

    this._fetchAngelsCursors = response.angels.pageInfo.endCursor

    return {
      angels: response.angels.nodes,
      hasNextPage: response.angels.pageInfo.hasNextPage,
    }
  }

  async fetchFeaturedAngels(): Promise<IUserBase[]> {
    const response = await this.sdk.fetchFeaturedAngels({}, this._headers())

    return response.featuredAngels
  }

  async fetchUser(input: FetchUserRequestInput): Promise<IUserBase> {
    const response = await this.sdk.fetchUser(
      {
        username: input.username,
        firstReferences: input.limitOfReference ? input.limitOfReference : null,
      },
      this._headers()
    )

    return response.user
  }

  async fetchUserForViewer(username: string): Promise<IUserBase> {
    const response = await this.sdk.fetchUserForViewer(
      {
        username,
      },
      this._headers()
    )

    return response.user
  }

  async updateMyProfile(profile: IUserProfileInputBase): Promise<IUserProfileBase> {
    const response = await this.sdk.updateMyProfile(
      {
        input: {
          attributes: profile,
        },
      },
      this._headers()
    )

    return response.updateMyProfile
  }

  async addExperience(input: AddExperienceRequestInput): Promise<IExperienceBase> {
    const response = await this.sdk.addExperience(
      {
        input: {
          attributes: input.experience,
        },
      },
      this._headers()
    )

    return response.addExperience
  }

  async updateExperience(input: UpdateExperienceRequestInput): Promise<IExperienceBase> {
    const response = await this.sdk.updateExperience(
      {
        input: {
          attributes: input.experience,
          id: input.id,
        },
      },
      this._headers()
    )

    return response.updateExperience
  }

  async removeExperience(input: RemoveExperienceRequestInput): Promise<IExperienceBase> {
    const response = await this.sdk.removeExperience(
      {
        input,
      },
      this._headers()
    )

    return response.removeExperience
  }

  // ============================================================
  // Companies
  // ============================================================
  async fetchCompanies(input: FetchCompaniesRequestInput): Promise<FetchCompaniesRequestOutput> {
    // サーバー側から実行するときはページ送りしないので、 after は指定しない
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else if (input.isVc) {
      after = this._fetchVentureCapitalsCursors
    } else {
      after = this._fetchStartupsCursors
    }

    const variables = {
      after,
      before: '',
      first: input.limit,
      isVc: input.isVc,
      marketIds: input.marketIds ? input.marketIds : [],
      maxInvestmentAmount: input.maxInvestmentAmount ? input.maxInvestmentAmount : null,
      minInvestmentAmount: input.minInvestmentAmount ? input.minInvestmentAmount : null,
      companySize: input.companySize ? input.companySize : null,
      roundIds: input.roundIds ? input.roundIds : [],
      investmentTargetMarketIds: input.investmentTargetMarketIds ? input.investmentTargetMarketIds : [],
      investmentTargetRoundIds: input.investmentTargetRoundIds ? input.investmentTargetRoundIds : [],
      locationIds: input.locationIds ? input.locationIds : [],
      currencyUnit: input.currencyUnit ? input.currencyUnit : null,
      orderBy: input.orderBy ? input.orderBy : null,
      query: input.searchWord ? input.searchWord : '',
    }
    const response = await this.sdk.fetchCompanies(variables, this._headers())

    if (input.isVc) {
      this._fetchVentureCapitalsCursors = response.companies.pageInfo.endCursor
    } else {
      this._fetchStartupsCursors = response.companies.pageInfo.endCursor
    }

    return {
      companies: response.companies.nodes,
      hasNextPage: response.companies.pageInfo.hasNextPage,
    }
  }

  async fetchFeaturedVentureCapitals(): Promise<ICompanyBase[]> {
    const response = await this.sdk.fetchFeaturedVentureCapitals({}, this._headers())

    return response.featuredVentureCapitals
  }

  async fetchFeaturedStartups(): Promise<ICompanyBase[]> {
    const response = await this.sdk.fetchFeaturedStartups({}, this._headers())

    return response.featuredStartups
  }

  async fetchCompaniesWithJobs(
    input: FetchCompaniesWithJobsRequestInput
  ): Promise<FetchCompaniesWithJobsRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else if (input.vcSlug) {
      after = this._fetchInvestmentsWithJobsOfVcCursors[input.vcSlug]
    } else if (input.angelUsername) {
      after = this._fetchInvestmentsWithJobsOfAngelCursors[input.angelUsername]
    } else {
      after = this._fetchCompaniesWithJobsCursors
    }

    const variables = {
      after,
      before: '',
      first: input.limit,
      firstJobs: 3, // Job の取得の件数
      isVc: input.isVc,
      marketIds: input.marketIds ? input.marketIds : [],
      maxInvestmentAmount: input.maxInvestmentAmount ? input.maxInvestmentAmount : null,
      minInvestmentAmount: input.minInvestmentAmount ? input.minInvestmentAmount : null,
      companySize: input.companySize ? input.companySize : null,
      roundIds: input.roundIds ? input.roundIds : [],
      investmentTargetMarketIds: input.investmentTargetMarketIds ? input.investmentTargetMarketIds : [],
      investmentTargetRoundIds: input.investmentTargetRoundIds ? input.investmentTargetRoundIds : [],
      companyLocationIds: input.companyLocationIds ? input.companyLocationIds : [],
      currencyUnit: input.currencyUnit ? input.currencyUnit : null,
      minMonthlySalary: input.minMonthlySalary ? input.minMonthlySalary : null,
      maxMonthlySalary: input.maxMonthlySalary ? input.maxMonthlySalary : null,
      equityGrant: input.equityGrant ? input.equityGrant : [],
      typeOfPosition: input.typeOfPosition ? input.typeOfPosition : [],
      workExperience: input.workExperience ? input.workExperience : null,
      workingForm: input.workingForm ? input.workingForm : [],
      jobCategoryIds: input.jobCategoryIds ? input.jobCategoryIds : [],
      skillIds: input.skillIds ? input.skillIds : [],
      jobLocationIds: input.jobLocationIds ? input.jobLocationIds : [],
      query: input.searchWord ? input.searchWord : '',
      vcSlug: input.vcSlug ? input.vcSlug : null,
      angelUsername: input.angelUsername ? input.angelUsername : null,
    }
    const response = await this.sdk.fetchCompaniesWithJobs(variables, this._headers())

    if (input.vcSlug) {
      this._fetchInvestmentsWithJobsOfVcCursors[input.vcSlug] = response.companiesWithJobs.pageInfo.endCursor
    } else if (input.angelUsername) {
      this._fetchInvestmentsWithJobsOfAngelCursors[input.angelUsername] = response.companiesWithJobs.pageInfo.endCursor
    } else {
      this._fetchCompaniesWithJobsCursors = response.companiesWithJobs.pageInfo.endCursor
    }

    return {
      companies: response.companiesWithJobs.nodes,
      hasNextPage: response.companiesWithJobs.pageInfo.hasNextPage,
    }
  }

  async fetchFeaturedCompaniesWithJobs(): Promise<ICompanyBase[]> {
    const variables = {
      firstJobs: 3, // Job の取得の件数
    }

    const response = await this.sdk.fetchFeaturedCompaniesWithJobs(variables, this._headers())

    return response.featuredCompaniesWithJobs
  }

  async searchCompany(input: SearchCompanyRequestInput): Promise<ICompanyBase[]> {
    const response = await this.sdk.searchCompany(
      {
        first: input.limit,
        query: input.searchWord,
      },
      this._headers()
    )

    return response.searchCompany.nodes
  }

  async fetchCompany(input: FetchCompanyRequestInput): Promise<ICompanyBase> {
    const response = await this.sdk.fetchCompany(
      {
        slug: input.slug,
        firstJobs: input.limitOfJob,
        firstReferences: input.limitOfReference ? input.limitOfReference : null,
      },
      this._headers()
    )

    return response.company
  }

  async fetchCompanyForViewer(slug: string): Promise<ICompanyBase> {
    const response = await this.sdk.fetchCompanyForViewer(
      {
        slug,
      },
      this._headers()
    )

    return response.company
  }

  async fetchMyCompany(input: FetchMyCompanyRequestInput): Promise<IMyCompanyBase> {
    const response = await this.sdk.fetchMyCompany(
      {
        slug: input.slug,
      },
      this._headers()
    )

    return response.myCompany
  }

  async createCompany(company: ICompanyInputBase): Promise<ICompanyBase> {
    const response = await this.sdk.createCompany(
      {
        input: {
          attributes: company,
        },
      },
      this._headers()
    )

    return response.createCompany
  }

  async createMyCompany(company: ICompanyInputBase): Promise<IMyCompanyBase> {
    const response = await this.sdk.createMyCompany(
      {
        input: {
          attributes: company,
        },
      },
      this._headers()
    )

    return response.createMyCompany
  }

  async updateCompany(input: UpdateCompanyRequestInput): Promise<IMyCompanyBase> {
    const response = await this.sdk.updateCompany(
      {
        input: {
          attributes: input.company,
          id: input.id,
        },
      },
      this._headers()
    )

    return response.updateCompany
  }

  async addCompanyMember(input: AddCompanyMemberRequestInput): Promise<IMyCompanyMemberBase> {
    const response = await this.sdk.addCompanyMember(
      {
        input: {
          attributes: input,
        },
      },
      this._headers()
    )

    return response.addCompanyMember
  }

  async updateCompanyMember(input: UpdateCompanyMemberRequestInput): Promise<IMyCompanyMemberBase> {
    const response = await this.sdk.updateCompanyMember(
      {
        input,
      },
      this._headers()
    )

    return response.updateCompanyMember
  }

  async removeCompanyMember(input: RemoveCompanyMemberRequestInput): Promise<IMyCompanyMemberBase> {
    const response = await this.sdk.removeCompanyMember(
      {
        input,
      },
      this._headers()
    )

    return response.removeCompanyMember
  }

  async addProduct(input: AddProductRequestInput): Promise<IProductBase> {
    const response = await this.sdk.addProduct(
      {
        input: {
          attributes: input.product,
          companyId: input.companyId,
        },
      },
      this._headers()
    )

    return response.addProduct
  }

  async updateProduct(input: UpdateProductRequestInput): Promise<IProductBase> {
    const response = await this.sdk.updateProduct(
      {
        input: {
          attributes: input.product,
          id: input.id,
        },
      },
      this._headers()
    )

    return response.updateProduct
  }

  async removeProduct(input: RemoveProductRequestInput): Promise<IProductBase> {
    const response = await this.sdk.removeProduct(
      {
        input,
      },
      this._headers()
    )

    return response.removeProduct
  }

  // ============================================================
  // Investments
  // ============================================================
  async addMyInvestment(input: AddMyInvestmentRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.addMyInvestment(
      {
        input: {
          attributes: input.investment,
        },
      },
      this._headers()
    )

    return response.addMyInvestment
  }

  async addInvestor(input: AddInvestorRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.addInvestor(
      {
        input: {
          attributes: input.investment,
        },
      },
      this._headers()
    )

    return response.addInvestor
  }

  async addCompanyInvestment(input: AddCompanyInvestmentRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.addCompanyInvestment(
      {
        input: {
          investingCompanyId: input.investingCompanyId,
          attributes: input.investment,
        },
      },
      this._headers()
    )

    return response.addCompanyInvestment
  }

  async updateInvestment(input: UpdateInvestmentRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.updateInvestment(
      {
        input: {
          id: input.id,
          attributes: input.investment,
        },
      },
      this._headers()
    )

    return response.updateInvestment
  }

  async updateInvestor(input: UpdateInvestorRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.updateInvestor(
      {
        input: {
          id: input.id,
          attributes: input.investment,
        },
      },
      this._headers()
    )

    return response.updateInvestor
  }

  async removeInvestment(input: RemoveInvestmentRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.removeInvestment(
      {
        input,
      },
      this._headers()
    )

    return response.removeInvestment
  }

  async removeInvestor(input: RemoveInvestorRequestInput): Promise<IInvestmentBase> {
    const response = await this.sdk.removeInvestor(
      {
        input,
      },
      this._headers()
    )

    return response.removeInvestor
  }

  // ============================================================
  // Articles
  // ============================================================
  async fetchArticle(slug: string): Promise<IArticleBase> {
    const response = await this.sdk.fetchArticle(
      {
        slug,
      },
      this._headers()
    )

    return response.article
  }

  async fetchArticles(input: FetchArticleRequestInput): Promise<FetchArticleRequestOutput> {
    const response = await this.sdk.fetchArticles(
      {
        after: typeof window !== 'undefined' ? this._fetchArticlesCursors[input.cursorKey] : '',
        before: '',
        first: input.limit,
        categories: input.categories,
      },
      this._headers()
    )

    this._fetchArticlesCursors[input.cursorKey] = response.articles.pageInfo.endCursor

    return {
      articles: response.articles.nodes,
      hasNextPage: response.articles.pageInfo.hasNextPage,
    }
  }

  async fetchCompanyArticles(input: FetchCompanyArticleRequestInput): Promise<FetchCompanyArticleRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchCompanyArticlesCursors[input.slug]
    }

    const response = await this.sdk.fetchCompanyArticles(
      {
        after,
        before: '',
        first: input.limit,
        slug: input.slug,
      },
      this._headers()
    )

    this._fetchCompanyArticlesCursors[input.slug] = response.companyArticles.pageInfo.endCursor

    return {
      articles: response.companyArticles.nodes,
      hasNextPage: response.companyArticles.pageInfo.hasNextPage,
    }
  }

  async fetchMyCompanyArticles(
    input: FetchMyCompanyArticlesRequestInput
  ): Promise<FetchMyCompanyArticlesRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else if (input.after) {
      after = input.after
    }

    const response = await this.sdk.fetchMyCompanyArticles(
      {
        after,
        before: '',
        first: input.limit,
        slug: input.slug,
      },
      this._headers()
    )

    return {
      articles: response.myCompany.articles.nodes,
      hasNextPage: response.myCompany.articles.pageInfo.hasNextPage,
      endCursor: response.myCompany.articles.pageInfo.endCursor, // Company の entity で endCursor を管理
    }
  }

  async fetchFeaturedStories(): Promise<IArticleBase[]> {
    const response = await this.sdk.fetchFeaturedStories({}, this._headers())

    return response.featuredStories
  }

  async createCompanyArticle(input: CreateCompanyArticleRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.createCompanyArticle(
      {
        input: {
          companyId: input.companyId,
          attributes: input.article,
        },
      },
      this._headers()
    )

    return response.createCompanyArticle
  }

  async updateCompanyArticle(input: UpdateCompanyArticleRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.updateCompanyArticle(
      {
        input: {
          id: input.id,
          attributes: input.article,
        },
      },
      this._headers()
    )

    return response.updateCompanyArticle
  }

  async fetchUserArticles(input: FetchUserArticlesRequestInput): Promise<FetchUserArticlesRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchUserArticlesCursors[input.username]
    }

    const response = await this.sdk.fetchUserArticles(
      {
        after,
        before: '',
        first: input.limit,
        username: input.username,
      },
      this._headers()
    )

    this._fetchUserArticlesCursors[input.username] = response.userArticles.pageInfo.endCursor

    return {
      articles: response.userArticles.nodes,
      hasNextPage: response.userArticles.pageInfo.hasNextPage,
    }
  }

  async fetchMyArticles(input: FetchMyArticlesRequestInput): Promise<FetchMyArticlesRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else if (input.after) {
      after = input.after
    }
    const response = await this.sdk.fetchMyArticles(
      {
        after,
        before: '',
        first: input.limit,
      },
      this._headers()
    )

    return {
      articles: response.myArticles.nodes,
      hasNextPage: response.myArticles.pageInfo.hasNextPage,
      endCursor: response.myArticles.pageInfo.endCursor, // Viewer の entity で endCursor を管理
    }
  }

  async createMyArticle(input: CreateMyArticleRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.createMyArticle(
      {
        input: {
          attributes: input.article,
        },
      },
      this._headers()
    )

    return response.createMyArticle
  }

  async updateMyArticle(input: UpdateMyArticleRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.updateMyArticle(
      {
        input: {
          id: input.id,
          attributes: input.article,
        },
      },
      this._headers()
    )

    return response.updateMyArticle
  }

  async deleteMyArticle(input: DeleteArticleRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.deleteMyArticle(
      {
        input,
      },
      this._headers()
    )

    return response.deleteMyArticle
  }

  async deleteCompanyArticle(input: DeleteArticleRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.deleteCompanyArticle(
      {
        input,
      },
      this._headers()
    )

    return response.deleteCompanyArticle
  }

  async toggleArticleLikedState(input: ToggleArticleLikedStateRequestInput): Promise<IArticleBase> {
    const response = await this.sdk.toggleArticleLikedState(
      {
        input,
      },
      this._headers()
    )

    return response.toggleArticleLikedState
  }

  async fetchPickedUpFeatures(): Promise<IArticleBase[]> {
    const response = await this.sdk.fetchPickedUpFeatures({}, this._headers())

    return response.pickedUpFeatures
  }

  // ============================================================
  // ArticleAttachment
  // ============================================================

  async createArticleAttachment(input: CreateArticleAttachmentRequestInput): Promise<IArticleAttachmentBase> {
    const response = await this.sdk.createArticleAttachment(
      {
        input: {
          attributes: input.articleAttachment,
        },
      },
      this._headers()
    )

    return response.createArticleAttachment
  }

  // ============================================================
  // Chat
  // ============================================================

  /**
   * 各スレッドの Subscription を初期化して格納
   * @param input
   */
  createChatMessageThreadSubscription(input: CreateChatMessageThreadsSubscriptionRequestInput): void {
    // すでに subscription が存在する場合は、スキップ
    const hasSameSubscription = this._actionCableConsumer.subscriptions.subscriptions.some((subscription) => {
      return subscription.identifier.includes(input.chatMessageThreadSlug)
    })
    if (hasSameSubscription) {
      return
    }

    this._actionCableSubscriptions[input.chatMessageThreadSlug] = this._actionCableConsumer.subscriptions.create(
      {
        channel: 'ChatChannel',
        message_thread_slug: input.chatMessageThreadSlug,
      },
      {
        connected: input?.onConnected,
        disconnected: input?.onDisconnected,
        received: input.onReceived,
      }
    )
  }

  async fetchChatMessages(input: FetchChatMessagesRequestInput): Promise<FetchChatMessagesRequestOutput> {
    const response = await this.sdk.fetchMessageThread(
      {
        slug: input.chatMessageTreadSlug,
        after: input.shouldRefresh ? '' : this._chatMessagesCursors[input.chatMessageTreadSlug],
        before: '',
        first: 30,
      },
      this._headers()
    )

    // カーソル格納
    this._chatMessagesCursors[response.messageThread.slug] = response.messageThread.messages.pageInfo.endCursor

    return {
      messages: response.messageThread.messages.nodes,
      hasNextPage: response.messageThread.messages.pageInfo.hasNextPage,
    }
  }

  async fetchChatMessageThreads(input: FetchChatMessageThreadsRequestInput): Promise<IChatMessageThreadBase[]> {
    const response = await this.sdk.fetchMessageThreads(
      {
        after: '',
        before: '',
        first: input.limitOfMessages,
      },
      this._headers()
    )

    return response.messageThreads
  }

  async fetchPaginatedChatMessageThreads(
    input: FetchPaginatedChatMessageThreadsRequestInput
  ): Promise<FetchPaginatedChatMessageThreadsRequestOutput> {
    const response = await this.sdk.fetchPaginatedMessageThreads(
      {
        after: input.cursor,
        before: '',
        first: input.limit,
        messagesAfter: '',
        messagesBefore: '',
        messagesFirst: input.limitOfMessages,
      },
      this._headers()
    )

    return {
      threads: response.paginatedMessageThreads.nodes,
      pageInfo: response.paginatedMessageThreads.pageInfo,
    }
  }

  async createChatMessageThread(input: CreateChatMessageThreadRequestInput): Promise<IChatMessageThreadBase> {
    const response = await this.sdk.createMessageThread(
      {
        input,
      },
      this._headers()
    )

    return response.createMessageThread
  }

  async markAllMessagesAsRead(input: MarkAllMessagesAsReadRequestInput): Promise<void> {
    await this.sdk.markAllMessagesAsRead(
      {
        input,
      },
      this._headers()
    )
  }

  // ============================================================
  // Markets
  // ============================================================

  async fetchMarkets(): Promise<IMarketBase[]> {
    const response = await this.sdk.fetchMarkets({}, this._headers())

    return response.markets
  }

  // ============================================================
  // Notifications
  // ============================================================

  async markNotificationsAsRead(
    input: MarkNotificationsAsReadRequestInput
  ): Promise<MarkNotificationsAsReadRequestOutput> {
    const response = await this.sdk.markNotificationsAsRead(
      {
        input,
      },
      this._headers()
    )

    return response.markNotificationsAsRead
  }

  // ============================================================
  // Locations
  // ============================================================
  async fetchLocations(input: FetchLocationsRequestInput): Promise<ILocationBase[]> {
    const response = await this.sdk.fetchLocations(
      {
        first: input.limit,
        query: input.searchWord,
      },
      this._headers()
    )

    return response.locations.nodes
  }

  async fetchLocation(input: FetchLocationRequestInput): Promise<ILocationBase> {
    const response = await this.sdk.fetchLocation(
      {
        id: input.id,
      },
      this._headers()
    )

    return response.location
  }

  // ============================================================
  // Pitches
  // ============================================================
  async fetchPitches(companySlug: string): Promise<IPitchBase[]> {
    const response = await this.sdk.fetchPitches(
      {
        companySlug,
      },
      this._headers()
    )

    return response.pitches
  }

  async fetchMyPitches(companySlug: string): Promise<IMyPitchBase[]> {
    const response = await this.sdk.fetchMyPitches(
      {
        companySlug,
      },
      this._headers()
    )

    return response.myPitches
  }

  async fetchPitch(slug: string): Promise<IPitchBase> {
    const response = await this.sdk.fetchPitch(
      {
        slug,
      },
      this._headers()
    )

    return response.pitch
  }

  async createPitch(input: CreatePitchRequestInput): Promise<IMyPitchBase> {
    const response = await this.sdk.createPitch(
      {
        input: {
          attributes: input.pitch,
          companyId: input.companyId,
        },
      },
      this._headers()
    )

    return response.createPitch
  }

  async deletePitch(input: DeletePitchRequestInput): Promise<IMyPitchBase> {
    const response = await this.sdk.deletePitch(
      {
        input,
      },
      this._headers()
    )

    return response.deletePitch
  }

  async updatePitch(input: UpdatePitchRequestInput): Promise<IMyPitchBase> {
    const response = await this.sdk.updatePitch(
      {
        input: {
          attributes: input.pitch,
          id: input.id,
        },
      },
      this._headers()
    )

    return response.updatePitch
  }

  async markPitchAsRead(slug: string): Promise<IPitchBase> {
    const response = await this.sdk.markPitchAsRead(
      {
        input: {
          slug,
        },
      },
      this._headers()
    )

    return response.markPitchAsRead
  }

  // ============================================================
  // Pitches
  // ============================================================
  async addPitchAttachment(input: AddPitchAttachmentRequestInput): Promise<IPitchAttachmentBase> {
    const response = await this.sdk.addPitchAttachment(
      {
        input: {
          attributes: input.pitchAttachment,
          pitchId: input.pitchId,
        },
      },
      this._headers()
    )

    return response.addPitchAttachment
  }

  async deletePitchAttachment(input: DeletePitchAttachmentRequestInput): Promise<IPitchAttachmentBase> {
    const response = await this.sdk.deletePitchAttachment(
      {
        input,
      },
      this._headers()
    )

    return response.deletePitchAttachment
  }

  async removePitchAttachmentFromPitch(
    input: RemovePitchAttachmentFromPitchRequestInput
  ): Promise<IPitchAttachmentBase> {
    const response = await this.sdk.removePitchAttachmentFromPitch(
      {
        input: {
          pitchAttachmentId: input.pitchAttachmentId,
          pitchId: input.pitchId,
        },
      },
      this._headers()
    )

    return response.removePitchAttachmentFromPitch
  }

  async updatePitchAttachment(input: UpdatePitchAttachmentRequestInput): Promise<IPitchAttachmentBase> {
    const response = await this.sdk.updatePitchAttachment(
      {
        input: {
          attributes: input.pitchAttachment,
          id: input.id,
        },
      },
      this._headers()
    )

    return response.updatePitchAttachment
  }

  // ============================================================
  // JobCategories
  // ============================================================

  async fetchJobCategories(): Promise<JobCategoryBase[]> {
    const response = await this.sdk.fetchJobCategories({}, this._headers())

    return response.jobCategories
  }

  // ============================================================
  // JobTags
  // ============================================================

  async fetchJobTags(): Promise<IJobTagBase[]> {
    const response = await this.sdk.fetchJobTags({}, this._headers())

    return response.jobTags
  }

  // ============================================================
  // Skills
  // ============================================================
  async fetchSkills(input: FetchLocationsRequestInput): Promise<ISkillBase[]> {
    const response = await this.sdk.fetchSkills({
      first: input.limit,
      query: input.searchWord,
    })

    return response.skills.nodes
  }

  async createSkill(input: CreateSkillRequestInput): Promise<ISkillBase> {
    const response = await this.sdk.createSkill(
      {
        input: {
          attributes: input,
        },
      },
      this._headers()
    )

    return response.createSkill
  }

  // ============================================================
  // Jobs
  // ============================================================
  async fetchJobs(input: FetchJobsRequestInput): Promise<FetchJobsRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchJobsCursors
    }

    const variables = {
      after,
      before: '',
      first: input.limit,
      query: input.searchWord ? input.searchWord : '',
      currencyUnit: input.currencyUnit ? input.currencyUnit : null,
      minMonthlySalary: input.minMonthlySalary ? input.minMonthlySalary : null,
      maxMonthlySalary: input.maxMonthlySalary ? input.maxMonthlySalary : null,
      equityGrant: input.equityGrant ? input.equityGrant : [],
      typeOfPosition: input.typeOfPosition ? input.typeOfPosition : [],
      workExperience: input.workExperience ? input.workExperience : null,
      workingForm: input.workingForm ? input.workingForm : [],
      jobCategoryIds: input.jobCategoryIds ? input.jobCategoryIds : [],
      skillIds: input.skillIds ? input.skillIds : [],
      locationIds: input.locationIds ? input.locationIds : [],
    }
    const response = await this.sdk.fetchJobs(variables, this._headers())

    this._fetchJobsCursors = response.jobs.pageInfo.endCursor

    return {
      jobs: response.jobs.nodes,
      hasNextPage: response.jobs.pageInfo.hasNextPage,
    }
  }

  async fetchCompanyJobs(input: FetchCompanyJobsRequestInput): Promise<FetchCompanyJobsRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchCompanyJobsCursors[input.companySlug]
    }

    const response = await this.sdk.fetchCompanyJobs(
      {
        after,
        before: '',
        first: input.limit,
        companySlug: input.companySlug,
      },
      this._headers()
    )

    this._fetchCompanyJobsCursors[input.companySlug] = response.companyJobs.pageInfo.endCursor

    return {
      jobs: response.companyJobs.nodes,
      hasNextPage: response.companyJobs.pageInfo.hasNextPage,
    }
  }

  async fetchMyJobs(input: FetchMyJobsRequestInput): Promise<FetchMyJobsRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchMyJobsCursors[input.companySlug]
    }

    const response = await this.sdk.fetchMyJobs(
      {
        after,
        before: '',
        first: input.limit,
        companySlug: input.companySlug,
      },
      this._headers()
    )

    this._fetchMyJobsCursors[input.companySlug] = response.myJobs.pageInfo.endCursor

    return {
      jobs: response.myJobs.nodes,
      hasNextPage: response.myJobs.pageInfo.hasNextPage,
    }
  }

  async fetchJob(input: FetchJobRequestInput): Promise<IJobBase> {
    const response = await this.sdk.fetchJob(
      {
        slug: input.slug,
      },
      this._headers()
    )

    return response.job
  }

  async createJob(input: CreateJobRequestInput): Promise<IJobBase> {
    const response = await this.sdk.createJob(
      {
        input: {
          companyId: input.companyId,
          attributes: input.job,
        },
      },
      this._headers()
    )

    return response.createJob
  }

  async duplicateJob(input: DuplicateJobRequestInput): Promise<IJobBase> {
    const response = await this.sdk.duplicateJob(
      {
        input: {
          id: input.id,
        },
      },
      this._headers()
    )

    return response.duplicateJob
  }

  async updateJob(input: UpdateJobRequestInput): Promise<IJobBase> {
    const response = await this.sdk.updateJob(
      {
        input: {
          id: input.id,
          attributes: input.job,
        },
      },
      this._headers()
    )

    return response.updateJob
  }

  async deleteJob(input: DeleteJobRequestInput): Promise<IJobBase> {
    const response = await this.sdk.deleteJob(
      {
        input: {
          id: input.id,
        },
      },
      this._headers()
    )

    return response.deleteJob
  }

  async addFootprintToJob(input: AddFootprintToJobInputBase): Promise<IJobBase> {
    const response = await this.sdk.addFootprintToJob(
      {
        input: {
          slug: input.slug,
          referer: input.referer,
        },
      },
      this._headers()
    )

    return response.addFootprintToJob
  }

  async fetchJobFootprints(input: FetchJobFootprintsRequestInput): Promise<FetchJobFootprintsRequestOutput> {
    // TODO: UI 変更時に jobSlug も考慮できるように調製
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = input.jobSlug
        ? this._fetchJobFootprintsCursors[input.jobSlug]
        : this._fetchJobFootprintsCursors[input.companySlug]
    }

    const variables = {
      after,
      before: '',
      first: input.limit,
      companySlug: input.companySlug,
      jobSlug: input.jobSlug ? input.jobSlug : null,
    }
    const response = await this.sdk.fetchJobFootprints(variables, this._headers())

    if (input.jobSlug) {
      this._fetchJobFootprintsCursors[input.jobSlug] = response.jobFootprints.pageInfo.endCursor
    }
    this._fetchJobFootprintsCursors[input.companySlug] = response.jobFootprints.pageInfo.endCursor

    return {
      jobFootprints: response.jobFootprints.nodes,
      hasNextPage: response.jobFootprints.pageInfo.hasNextPage,
    }
  }

  async fetchFeaturedJobs(): Promise<IJobBase[]> {
    const response = await this.sdk.fetchFeaturedJobs()

    return response.featuredJobs
  }

  // ============================================================
  // JobAttachment
  // ============================================================

  async createJobAttachment(input: CreateJobAttachmentRequestInput): Promise<IJobAttachmentBase> {
    const response = await this.sdk.createJobAttachment(
      {
        input: {
          attributes: input.jobAttachment,
        },
      },
      this._headers()
    )

    return response.createJobAttachment
  }

  // ============================================================
  // JobApplication
  // ============================================================
  async fetchJobApplications(input: FetchJobApplicationsRequestInput): Promise<FetchJobApplicationsRequestOutput> {
    const response = await this.sdk.fetchJobApplications(
      {
        after: '',
        before: '',
        first: input.limitOfMessage,
        after1: '',
        before1: '',
        first1: input.limitOfJopApplication,
        companySlug: input.companySlug,
      },
      this._headers()
    )

    return {
      jobApplications: response.jobApplications.nodes,
      hasNextPage: response.jobApplications.pageInfo.hasNextPage,
    }
  }

  async applyForJob(input: ApplyForJobRequestInput): Promise<IJobApplicationBase> {
    const response = await this.sdk.applyForJob(
      {
        input,
      },
      this._headers()
    )

    return response.applyForJob
  }

  // ============================================================
  // Subscription
  // ============================================================
  async createBillingPortalSession(input: CreateBillingPortalSessionInputBase): Promise<BillingPortalBase> {
    const response = await this.sdk.createBillingPortalSession(
      {
        input,
      },
      this._headers()
    )

    return response.createBillingPortalSession
  }

  async createRecruitSubscription(input: CreateRecruitSubscriptionInputBase): Promise<PaymentIntentBase> {
    const response = await this.sdk.createRecruitSubscription(
      {
        input,
      },
      this._headers()
    )

    return response.createRecruitSubscription
  }

  // ============================================================
  // JobBookmark
  // ============================================================
  async fetchMyJobBookmarks(input: FetchMyJobBookmarksRequestInput): Promise<FetchMyJobBookmarksRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchMyJobBookmarksCursors
    }

    const response = await this.sdk.fetchMyJobBookmarks(
      {
        after,
        before: '',
        first: input.limit,
      },
      this._headers()
    )

    this._fetchMyJobBookmarksCursors = response.myJobBookmarks.pageInfo.endCursor

    return {
      jobBookmarks: response.myJobBookmarks.nodes,
      hasNextPage: response.myJobBookmarks.pageInfo.hasNextPage,
    }
  }

  async addMyJobBookmark(input: AddMyJobBookmarkRequestInput): Promise<IJobBookmarkBase> {
    const response = await this.sdk.addMyJobBookmark(
      {
        input: {
          jobId: input.jobId,
        },
      },
      this._headers()
    )

    return response.addMyJobBookmark
  }

  async removeMyJobBookmark(input: RemoveMyJobBookmarkRequestInput): Promise<IJobBookmarkBase> {
    const response = await this.sdk.removeMyJobBookmark(
      {
        input: {
          jobId: input.jobId,
        },
      },
      this._headers()
    )

    return response.removeMyJobBookmark
  }

  async fetchJobBookmarks(input: FetchJobBookmarksRequestInput): Promise<FetchJobBookmarksRequestOutput> {
    const variable = {
      after: '',
      before: '',
      first: input.limit,
      companySlug: input.companySlug ? input.companySlug : null,
      jobSlug: input.jobSlug ? input.jobSlug : null,
    }

    const response = await this.sdk.fetchJobBookmarks(variable, this._headers())

    return {
      jobBookmarks: response.jobBookmarks.nodes,
      hasNextPage: response.jobBookmarks.pageInfo.hasNextPage,
    }
  }

  // ============================================================
  // Invitation
  // ============================================================
  async validInvitationToken(input: ValidInvitationTokenRequestInput): Promise<IInvitationBase> {
    const response = await this.sdk.validInvitationToken(
      {
        token: input.token,
      },
      this._headers()
    )

    return response.validInvitationToken
  }

  // ============================================================
  // Follow, Follower
  // ============================================================
  async toggleFollowCompany(input: ToggleFollowCompanyRequestInput): Promise<ICompanyBase> {
    const response = await this.sdk.toggleFollowCompany(
      {
        input,
      },
      this._headers()
    )

    return response.toggleFollowCompany
  }

  async addAngelInvitation(input: AddAngelInvitationRequestInput): Promise<IInvitationLinkBase> {
    const response = await this.sdk.addAngelInvitation(
      {
        input: {
          companyId: input.companyId,
          days: input.days,
          emails: input.emails ? input.emails : [],
        },
      },
      this._headers()
    )
    return response.addAngelInvitation
  }

  async toggleFollowUser(input: ToggleFollowUserRequestInput): Promise<IUserBase> {
    const response = await this.sdk.toggleFollowUser(
      {
        input,
      },
      this._headers()
    )

    return response.toggleFollowUser
  }

  async addVcInvitation(input: AddVcInvitationRequestInput): Promise<IInvitationLinkBase> {
    const response = await this.sdk.addVcInvitation(
      {
        input: {
          companyId: input.companyId,
          days: input.days,
          emails: input.emails ? input.emails : [],
        },
      },
      this._headers()
    )

    return response.addVcInvitation
  }

  async addAngelInvestmentInvitation(input: AddAngelInvestmentInvitationRequestInput): Promise<IInvitationLinkBase> {
    const response = await this.sdk.addAngelInvestmentInvitation(
      {
        input: {
          days: input.days,
          emails: input.emails ? input.emails : [],
        },
      },
      this._headers()
    )

    return response.addAngelInvestmentInvitation
  }

  async addVcInvestmentInvitation(input: AddVcInvestmentInvitationRequestInput): Promise<IInvitationLinkBase> {
    const response = await this.sdk.addVcInvestmentInvitation(
      {
        input: {
          companyId: input.companyId,
          days: input.days,
          emails: input.emails ? input.emails : [],
        },
      },
      this._headers()
    )

    return response.addVcInvestmentInvitation
  }

  async fetchFollowing(input: FetchFollowingRequestInput): Promise<FetchFollowingRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchFollowingCursors[input.username]
    }

    const variable = {
      after,
      before: '',
      first: input.limit,
      username: input.username,
    }

    const response = await this.sdk.fetchFollowing(variable, this._headers())

    this._fetchFollowingCursors[input.username] = response.following.pageInfo.endCursor

    return {
      following: response.following.nodes,
      hasNextPage: response.following.pageInfo.hasNextPage,
    }
  }

  async fetchFollowers(input: FetchFollowersRequestInput): Promise<FetchFollowersRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else if (input.entityType === FollowableEntityEntityType.COMPANY) {
      after = this._fetchCompanyFollowersCursors[input.slug]
    } else {
      after = this._fetchUserFollowersCursors[input.slug]
    }

    const variable = {
      after,
      before: '',
      first: input.limit,
      slug: input.slug,
      entityType: input.entityType,
    }

    const response = await this.sdk.fetchFollowers(variable, this._headers())

    if (input.entityType === FollowableEntityEntityType.COMPANY) {
      this._fetchCompanyFollowersCursors[input.slug] = response.followers.pageInfo.endCursor
    } else {
      this._fetchUserFollowersCursors[input.slug] = response.followers.pageInfo.endCursor
    }

    return {
      followers: response.followers.nodes,
      hasNextPage: response.followers.pageInfo.hasNextPage,
    }
  }

  // ============================================================
  // NotificationSettings
  // ============================================================
  async updateCompanyNotificationSettings(input: UpdateCompanyNotificationSettingsRequestInput): Promise<ICompanyBase> {
    const response = await this.sdk.updateCompanyNotificationSettings(
      {
        input,
      },
      this._headers()
    )

    return response.updateCompanyNotificationSettings
  }

  async addMemberInvitation(input: AddMemberInvitationRequestInput): Promise<IInvitationLinkBase> {
    const response = await this.sdk.addMemberInvitation(
      {
        input: {
          companyId: input.companyId,
          days: input.days,
          emails: input.emails ? input.emails : [],
        },
      },
      this._headers()
    )
    return response.addMemberInvitation
  }

  async updateUserNotificationSettings(input: UpdateUserNotificationSettingsRequestInput): Promise<IUserBase> {
    const response = await this.sdk.updateUserNotificationSettings(
      {
        input,
      },
      this._headers()
    )

    return response.updateUserNotificationSettings
  }

  // ============================================================
  // FetchNotifications
  // ============================================================
  async fetchNotifications(input: FetchNotificationsRequestInput): Promise<IViewerBase> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = input.cursor
    }

    const variables = {
      after,
      before: '',
      first: input.limit,
    }

    const response = await this.sdk.fetchNotifications(variables, this._headers())

    return response.me
  }

  // ============================================================
  // UserReferences
  // ============================================================
  async addUserReference(input: AddUserReferenceRequestInput): Promise<IUserReferenceBase> {
    const response = await this.sdk.addUserReference(
      {
        input: {
          username: input.username,
          comment: input.comment,
        },
      },
      this._headers()
    )

    return response.addUserReference
  }

  async updateUserReference(input: UpdateUserReferenceRequestInput): Promise<IUserReferenceBase> {
    const response = await this.sdk.updateUserReference(
      {
        input: {
          id: input.id,
          comment: input.comment,
        },
      },
      this._headers()
    )

    return response.updateUserReference
  }

  async removeUserReference(input: RemoveUserReferenceRequestInput): Promise<IUserReferenceBase> {
    const response = await this.sdk.removeUserReference(
      {
        input: {
          id: input.id,
        },
      },
      this._headers()
    )

    return response.removeUserReference
  }

  async fetchMyReferences(input: FetchMyReferencesRequestInput): Promise<FetchMyReferencesRequestOutput> {
    // ページ送りしないので一旦 after には空文字を指定
    const variable = {
      after: '',
      before: '',
      first: input.limit,
    }

    const response = await this.sdk.fetchMyReferences(variable, this._headers())

    return {
      userReferences: response.myReferences.nodes,
      hasNextPage: response.myReferences.pageInfo.hasNextPage,
    }
  }

  async updateMyReference(input: UpdateMyReferenceRequestInput): Promise<IUserReferenceBase> {
    const response = await this.sdk.updateMyReference(
      {
        input: {
          id: input.id,
          status: input.status,
        },
      },
      this._headers()
    )

    return response.updateMyReference
  }

  // ============================================================
  // CompanyReferences
  // ============================================================
  async addCompanyReference(input: AddCompanyReferenceRequestInput): Promise<ICompanyReferenceBase> {
    const response = await this.sdk.addCompanyReference(
      {
        input: {
          slug: input.slug,
          comment: input.comment,
        },
      },
      this._headers()
    )

    return response.addCompanyReference
  }

  async updateCompanyReference(input: UpdateCompanyReferenceRequestInput): Promise<ICompanyReferenceBase> {
    const response = await this.sdk.updateCompanyReference(
      {
        input: {
          id: input.id,
          comment: input.comment,
        },
      },
      this._headers()
    )

    return response.updateCompanyReference
  }

  async removeCompanyReference(input: RemoveCompanyReferenceRequestInput): Promise<ICompanyReferenceBase> {
    const response = await this.sdk.removeCompanyReference(
      {
        input: {
          id: input.id,
        },
      },
      this._headers()
    )

    return response.removeCompanyReference
  }

  async fetchMyCompanyReferences(
    input: FetchMyCompanyReferencesRequestInput
  ): Promise<FetchMyCompanyReferencesRequestOutput> {
    // ページ送りしないので一旦 after には空文字を指定
    const variable = {
      after: '',
      before: '',
      first: input.limit,
      slug: input.slug,
    }

    const response = await this.sdk.fetchMyCompanyReferences(variable, this._headers())

    return {
      companyReferences: response.myCompanyReferences.nodes,
      hasNextPage: response.myCompanyReferences.pageInfo.hasNextPage,
    }
  }

  async updateMyCompanyReference(input: UpdateMyCompanyReferenceRequestInput): Promise<ICompanyReferenceBase> {
    const response = await this.sdk.updateMyCompanyReference(
      {
        input: {
          id: input.id,
          status: input.status,
        },
      },
      this._headers()
    )

    return response.updateMyCompanyReference
  }

  async fetchMyInvestorMembers(): Promise<IViewerBase> {
    const response = await this.sdk.fetchMyInvestorMembers({}, this._headers())

    return response.me
  }

  async fetchVehicle(slug: string): Promise<IVehicleBase> {
    const response = await this.sdk.fetchVehicle({ slug, first: 10 }, this._headers())

    return response.vehicle
  }

  async fetchVehicleItems(input: FetchVehicleItemsRequestInput): Promise<FetchVehicleItemsRequestOutput> {
    const response = await this.sdk.fetchVehicleItems(
      {
        after: input.cursor,
        before: '',
        first: input.limit,
        query: input.query ? input.query : null,
        vehicleStatusIds: input.vehicleStatusIds,
        vehicleSlug: input.vehicleSlug,
      },
      this._headers()
    )

    return {
      vehicleItems: response.vehicleItems.nodes,
      cursor: response.vehicleItems.pageInfo.endCursor,
      hasNextPage: response.vehicleItems.pageInfo.hasNextPage,
    }
  }

  async fetchVehicleItemsForAllStatuses(
    input: FetchVehicleItemsForAllStatusesRequestInput
  ): Promise<FetchVehicleItemsForAllStatusesRequestOutput> {
    const response = await this.sdk.fetchVehicleItemsForAllStatuses(
      {
        vehicleSlug: input.vehicleSlug,
        after1: input.params1.cursor,
        before1: '',
        first1: input.params1.limit,
        query1: input.params1.query || null,
        after2: input.params2.cursor,
        before2: '',
        first2: input.params2.limit,
        query2: input.params2.query || null,
        after3: input.params3.cursor,
        before3: '',
        first3: input.params3.limit,
        query3: input.params3.query || null,
        after4: input.params4.cursor,
        before4: '',
        first4: input.params4.limit,
        query4: input.params4.query || null,
      },
      this._headers()
    )

    return {
      data1: {
        vehicleItems: response.vehicleItems1.nodes,
        cursor: response.vehicleItems1.pageInfo.endCursor,
        hasNextPage: response.vehicleItems1.pageInfo.hasNextPage,
      },
      data2: {
        vehicleItems: response.vehicleItems2.nodes,
        cursor: response.vehicleItems2.pageInfo.endCursor,
        hasNextPage: response.vehicleItems2.pageInfo.hasNextPage,
      },
      data3: {
        vehicleItems: response.vehicleItems3.nodes,
        cursor: response.vehicleItems3.pageInfo.endCursor,
        hasNextPage: response.vehicleItems3.pageInfo.hasNextPage,
      },
      data4: {
        vehicleItems: response.vehicleItems4.nodes,
        cursor: response.vehicleItems4.pageInfo.endCursor,
        hasNextPage: response.vehicleItems4.pageInfo.hasNextPage,
      },
    }
  }

  async fetchVehicleItem(id: string): Promise<IVehicleItemBase> {
    // TODO: portfolioNotes の pagenation 管理用の cursor を用意する
    // TODO: portfolioMeetings の pagenation 管理用の cursor を用意する
    const response = await this.sdk.fetchVehicleItem(
      {
        afterPortfolioNotes: '',
        beforePortfolioNotes: '',
        firstPortfolioNotes: 100,
        afterPortfolioMeetings: '',
        beforePortfolioMeetings: '',
        firstPortfolioMeetings: 100,
        id,
      },
      this._headers()
    )

    return response.vehicleItem
  }

  // TODO: 実装
  /* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-return */
  async addVehicleItemPortfolioAttachment(
    input: AddVehicleItemPortfolioAttachmentRequestInput
  ): Promise<IPortfolioAttachmentBase> {
    const response = await this.sdk.addVehicleItemPortfolioAttachment(
      {
        input: {
          vehicleItemId: input.vehicleItemId,
          attributes: input.attachment,
        },
      },
      this._headers()
    )

    return response.addVehicleItemPortfolioAttachment
  }

  async addVehicleItemRoundAttachment(
    input: AddVehicleItemRoundAttachmentRequestInput
  ): Promise<IVehicleItemRoundAttachmentBase> {
    const response = await this.sdk.addVehicleItemRoundAttachment(
      {
        input: {
          vehicleItemRoundId: input.vehicleItemRoundId,
          attributes: input.attachment,
        },
      },
      this._headers()
    )

    return response.addVehicleItemRoundAttachment
  }

  async addVehicleMember(input: AddVehicleMemberRequestInput): Promise<IVehicleMemberBase> {
    const response = await this.sdk.addVehicleMember(
      {
        input: {
          vehicleId: input.vehicleId,
          userId: input.userId,
          investorMemberRole: input.investorMemberRole,
          vehicleMemberRole: input.vehicleMemberRole,
        },
      },
      this._headers()
    )

    return response.addVehicleMember
  }

  async createVehicle(input: CreateVehicleRequestInput): Promise<IVehicleBase> {
    const response = await this.sdk.createVehicle({ input }, this._headers())

    return response.createVehicle
  }

  async createVehicleItem(input: CreateVehicleItemRequestInput): Promise<IVehicleItemBase> {
    // TODO: portfolioNotes の pagenation 管理用の cursor を用意する
    const response = await this.sdk.createVehicleItem(
      {
        afterPortfolioNotes: '',
        beforePortfolioNotes: '',
        firstPortfolioNotes: 100,
        afterPortfolioMeetings: '',
        beforePortfolioMeetings: '',
        firstPortfolioMeetings: 100,
        input: {
          vehicleStatusId: input.vehicleStatusId,
          captainUserId: input.captainUserId,
          companyId: input.companyId,
          attributes: input.vehicleItem ? input.vehicleItem : null,
          roundAttributes: input.vehicleItemRound,
        },
      },
      this._headers()
    )

    return response.createVehicleItem
  }

  async createVehicleItemPortfolioNote(input: CreateVehicleItemPortfolioNoteRequestInput): Promise<IPortfolioNoteBase> {
    const response = await this.sdk.createVehicleItemPortfolioNote(
      {
        input: {
          vehicleItemId: input.vehicleItemId,
          attributes: input.portfolioNote,
        },
      },
      this._headers()
    )

    return response.createVehicleItemPortfolioNote
  }

  async createVehicleItemPortfolioMeeting(
    input: CreateVehicleItemPortfolioMeetingRequestInput
  ): Promise<IPortfolioMeetingBase> {
    const response = await this.sdk.createVehicleItemPortfolioMeeting(
      {
        input: {
          vehicleItemId: input.vehicleItemId,
          attributes: input.portfolioMeeting,
        },
      },
      this._headers()
    )

    return response.createVehicleItemPortfolioMeeting
  }

  async createVehicleItemRound(input: CreateVehicleItemRoundRequestInput): Promise<IVehicleItemRoundBase> {
    const response = await this.sdk.createVehicleItemRound(
      {
        input: {
          vehicleItemId: input.vehicleItemId,
          attributes: input.vehicleItemRound,
        },
      },
      this._headers()
    )

    return response.createVehicleItemRound
  }

  async createVehicleStatus(input: CreateVehicleStatusRequestInput): Promise<IVehicleStatusBase> {
    const response = await this.sdk.createVehicleStatus(
      {
        after: '',
        before: '',
        first: 0,
        input: {
          vehicleSlug: input.vehicleSlug,
          attributes: input.vehicleStatus,
        },
      },
      this._headers()
    )

    return response.createVehicleStatus
  }

  async deleteVehicle(id: string): Promise<IVehicleBase> {
    const response = await this.sdk.deleteVehicle({ input: { id } }, this._headers())

    return response.deleteVehicle
  }

  async deleteVehicleItem(id: string): Promise<IVehicleItemBase> {
    // TODO: portfolioNotes の pagenation 管理用の cursor を用意する
    const response = await this.sdk.deleteVehicleItem(
      {
        afterPortfolioNotes: '',
        beforePortfolioNotes: '',
        firstPortfolioNotes: 100,
        afterPortfolioMeetings: '',
        beforePortfolioMeetings: '',
        firstPortfolioMeetings: 100,
        input: {
          id,
        },
      },
      this._headers()
    )

    return response.deleteVehicleItem
  }

  async deleteVehicleItemPortfolioAttachment(
    input: DeleteVehicleItemPortfolioAttachmentRequestInput
  ): Promise<IPortfolioAttachmentBase> {
    const response = await this.sdk.deleteVehicleItemPortfolioAttachment(
      {
        input: {
          id: input.id,
          vehicleItemId: input.vehicleItemId,
        },
      },
      this._headers()
    )

    return response.deleteVehicleItemPortfolioAttachment
  }

  async deleteVehicleItemPortfolioNote(input: DeleteVehicleItemPortfolioNoteRequestInput): Promise<IPortfolioNoteBase> {
    const response = await this.sdk.deleteVehicleItemPortfolioNote(
      {
        input: {
          id: input.id,
          vehicleItemId: input.vehicleItemId,
        },
      },
      this._headers()
    )

    return response.deleteVehicleItemPortfolioNote
  }

  async deleteVehicleItemPortfolioMeeting(
    input: DeleteVehicleItemPortfolioMeetingRequestInput
  ): Promise<IPortfolioMeetingBase> {
    const response = await this.sdk.deleteVehicleItemPortfolioMeeting(
      {
        input: {
          id: input.id,
          vehicleItemId: input.vehicleItemId,
        },
      },
      this._headers()
    )

    return response.deleteVehicleItemPortfolioMeeting
  }

  async deleteVehicleItemRound(id: string): Promise<IVehicleItemRoundBase> {
    const response = await this.sdk.deleteVehicleItemRound(
      {
        input: {
          id,
        },
      },
      this._headers()
    )

    return response.deleteVehicleItemRound
  }

  async deleteVehicleItemRoundAttachment(id: string): Promise<IVehicleItemRoundAttachmentBase> {
    const response = await this.sdk.deleteVehicleItemRoundAttachment(
      {
        input: {
          id,
        },
      },
      this._headers()
    )

    return response.deleteVehicleItemRoundAttachment
  }

  async deleteVehicleStatus(id: string): Promise<IVehicleStatusBase> {
    const response = await this.sdk.deleteVehicleStatus(
      {
        after: '',
        before: '',
        first: 0,
        input: {
          id,
        },
      },
      this._headers()
    )

    return response.deleteVehicleStatus
  }

  async fetchVehicleAnalytics(vehicleSlug: string): Promise<IVehicleDashboardBase[]> {
    const response = await this.sdk.fetchVehicleAnalytics({ vehicleSlug }, this._headers())

    return response.vehicleAnalytics
  }

  async removeVehicleMember(id: string): Promise<IVehicleMemberBase> {
    const response = await this.sdk.removeVehicleMember(
      {
        input: {
          id,
        },
      },
      this._headers()
    )

    return response.removeVehicleMember
  }

  async updateVehicle(input: UpdateVehicleRequestInput): Promise<IVehicleBase> {
    const response = await this.sdk.updateVehicle({ input }, this._headers())

    return response.updateVehicle
  }

  async updateVehicleItem(input: UpdateVehicleItemRequestInput): Promise<IVehicleItemBase> {
    // TODO: portfolioNotes の pagenation 管理用の cursor を用意する
    const response = await this.sdk.updateVehicleItem(
      {
        afterPortfolioNotes: '',
        beforePortfolioNotes: '',
        firstPortfolioNotes: 100,
        afterPortfolioMeetings: '',
        beforePortfolioMeetings: '',
        firstPortfolioMeetings: 100,
        input: {
          id: input.id,
          vehicleStatusId: input.vehicleStatusId,
          captainUserId: input.captainUserId ? input.captainUserId : null,
          attributes: input.vehicleItem ? input.vehicleItem : null,
        },
      },
      this._headers()
    )

    return response.updateVehicleItem
  }

  async updateVehicleItemPortfolio(input: UpdateVehicleItemPortfolioRequestInput): Promise<IPortfolioBase> {
    // TODO: portfolioNotes の pagenation 管理用の cursor を用意する
    const response = await this.sdk.updateVehicleItemPortfolio(
      {
        afterPortfolioNotes: '',
        beforePortfolioNotes: '',
        firstPortfolioNotes: 100,
        afterPortfolioMeetings: '',
        beforePortfolioMeetings: '',
        firstPortfolioMeetings: 100,
        input: {
          id: input.id,
          vehicleItemId: input.vehicleItemId,
          attributes: input.portfolio,
        },
      },
      this._headers()
    )

    return response.updateVehicleItemPortfolio
  }

  async updateVehicleItemPortfolioNote(input: UpdateVehicleItemPortfolioNoteRequestInput): Promise<IPortfolioNoteBase> {
    const response = await this.sdk.updateVehicleItemPortfolioNote(
      {
        input: {
          id: input.id,
          vehicleItemId: input.vehicleItemId,
          attributes: input.portfolioNote,
        },
      },
      this._headers()
    )

    return response.updateVehicleItemPortfolioNote
  }

  async updateVehicleItemPortfolioMeeting(
    input: UpdateVehicleItemPortfolioMeetingRequestInput
  ): Promise<IPortfolioMeetingBase> {
    const response = await this.sdk.updateVehicleItemPortfolioMeeting(
      {
        input: {
          id: input.id,
          vehicleItemId: input.vehicleItemId,
          attributes: input.portfolioMeeting,
        },
      },
      this._headers()
    )

    return response.updateVehicleItemPortfolioMeeting
  }

  async updateVehicleItemRound(input: UpdateVehicleItemRoundRequestInput): Promise<IVehicleItemRoundBase> {
    const response = await this.sdk.updateVehicleItemRound(
      {
        input: {
          id: input.id,
          attributes: input.vehicleItemRound,
        },
      },
      this._headers()
    )

    return response.updateVehicleItemRound
  }

  async updateVehicleMember(input: UpdateVehicleMemberRequestInput): Promise<IVehicleMemberBase> {
    const response = await this.sdk.updateVehicleMember(
      {
        input: {
          id: input.id,
          role: input.vehicleMemberRole,
        },
      },
      this._headers()
    )

    return response.updateVehicleMember
  }

  async updateVehicleStatus(input: UpdateVehicleStatusRequestInput): Promise<IVehicleStatusBase> {
    const response = await this.sdk.updateVehicleStatus(
      {
        after: '',
        before: '',
        first: 0,
        input: {
          vehicleStatusId: input.id,
          attributes: input.vehicleStatus,
        },
      },
      this._headers()
    )

    return response.updateVehicleStatus
  }
  /* eslint-enable @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-return */

  async initializePms(input: InitializePmsRquestInput): Promise<IInvestorMemberBase> {
    const response = await this.sdk.initializePms({ input }, this._headers())

    return response.initializePms
  }

  async fetchForexRate(input: FetchForexRateRequestInput): Promise<IForexRateBase> {
    const response = await this.sdk.fetchForexRate(
      {
        tickerSymbol: input.tickerSymbol,
      },
      this._headers()
    )

    return response.forexRate
  }

  async fetchForexRates(input: FetchForexRatesRequestInput): Promise<IForexRateBase[]> {
    const [tickerSymbol1, tickerSymbol2] = input.tickerSymbols
    const response = await this.sdk.fetchForexRates(
      {
        tickerSymbol1,
        tickerSymbol2,
      },
      this._headers()
    )

    return [response.forexRate1, response.forexRate2]
  }

  // ============================================================
  // Subsidies
  // ============================================================
  async fetchSubsidies(input: FetchSubsidiesRequestInput): Promise<FetchSubsidiesRequestOutput> {
    let after = ''
    if (input.shouldRefresh) {
      after = ''
    } else {
      after = this._fetchSubsidiesCursors
    }

    const variables = {
      after,
      before: '',
      first: input.limit,
      query: input.searchWord ? input.searchWord : '',
      locationsId: input.locationsId ? input.locationsId : null,
      subsidyPurposeIds: input.subsidyPurposeIds ? input.subsidyPurposeIds : [],
    }
    const response = await this.sdk.fetchSubsidies(variables, this._headers())

    this._fetchSubsidiesCursors = response.subsidies.pageInfo.endCursor

    return {
      subsidies: response.subsidies.nodes,
      hasNextPage: response.subsidies.pageInfo.hasNextPage,
    }
  }

  async fetchSubsidy(input: FetchSubsidyRequestInput): Promise<ISubsidyBase> {
    const response = await this.sdk.fetchSubsidy({ id: input.id }, this._headers())

    return response.subsidy
  }

  // ============================================================
  // SubsidyPurposes
  // ============================================================
  async fetchSubsidyPurposes(): Promise<ISubsidyPurposeBase[]> {
    const response = await this.sdk.fetchSubsidyPurposes({}, this._headers())

    return response.subsidyPurposes
  }

  async fetchSubsidyPurpose(input: FetchSubsidyPurposeRequestInput): Promise<ISubsidyPurposeBase> {
    const response = await this.sdk.fetchSubsidyPurpose({ id: input.id }, this._headers())

    return response.subsidyPurpose
  }
}
